import { useEffect } from 'react';
import { useI18n } from '../i18n/i18nContext';

export const useDocumentTitle = (pageTitle?: string) => {
  const { t } = useI18n();

  useEffect(() => {
    const baseTitle = t.common.appTitle;
    // Changed separator from ' - ' to ' | '
    document.title = pageTitle ? `${pageTitle} | ${baseTitle}` : baseTitle;
  }, [t.common.appTitle, pageTitle]);
};